import { hash } from './rng';

/** 2D gradient (Perlin-style) noise in [-1,1], seeded, deterministic. */
export function noise2(seed: number, x: number, y: number): number {
  const x0 = Math.floor(x), y0 = Math.floor(y);
  const fx = x - x0, fy = y - y0;
  const u = fade(fx), v = fade(fy);
  const n00 = grad(seed, x0, y0, fx, fy);
  const n10 = grad(seed, x0 + 1, y0, fx - 1, fy);
  const n01 = grad(seed, x0, y0 + 1, fx, fy - 1);
  const n11 = grad(seed, x0 + 1, y0 + 1, fx - 1, fy - 1);
  return lerp(lerp(n00, n10, u), lerp(n01, n11, u), v) * 1.41;
}

function fade(t: number): number { return t * t * t * (t * (t * 6 - 15) + 10); }
function lerp(a: number, b: number, t: number): number { return a + (b - a) * t; }
function grad(seed: number, ix: number, iy: number, dx: number, dy: number): number {
  const h = hash(seed, ix, iy) & 7;
  const gx = [1, -1, 1, -1, 1, -1, 0, 0][h], gy = [1, 1, -1, -1, 0, 0, 1, -1][h];
  return gx * dx + gy * dy;
}

/** Fractal Brownian motion, output normalised to [0,1]. */
export function fbm(seed: number, x: number, y: number, octaves = 4, lacunarity = 2, gain = 0.5): number {
  let amp = 1, freq = 1, sum = 0, norm = 0;
  for (let i = 0; i < octaves; i++) {
    sum += noise2(seed + i * 1013, x * freq, y * freq) * amp;
    norm += amp;
    amp *= gain; freq *= lacunarity;
  }
  const v = sum / norm; // roughly [-1,1]
  return Math.min(1, Math.max(0, v * 0.5 + 0.5));
}
